import type { PageViewMode } from '@/components/pages/home'

const pad4 = (n: number) => String(n).padStart(4, '0')

export type SpreadPageIndicator = { left: number | null; right: number | null }

type SpreadPageLabelsArgs = {
  spreadIndex: number
  safeTotalPages: number
  pageViewMode: PageViewMode
  spreadPageIndicator?: SpreadPageIndicator
}

/**
 * Zero-padded page numbers shown either side of the spine in the center indicator. A side is
 * empty when its page doesn't exist (single-page modes, or outside `1..totalPages`).
 */
export function resolveSpreadPageLabels({
  spreadIndex,
  safeTotalPages,
  pageViewMode,
  spreadPageIndicator,
}: SpreadPageLabelsArgs): {
  hasLeftPage: boolean
  hasRightPage: boolean
  leftLabel: string
  rightLabel: string
} {
  const leftPageNumber = (() => {
    if (spreadPageIndicator) return spreadPageIndicator.left
    if (pageViewMode === 'single-first') return null
    return 2 * spreadIndex
  })()

  const rightPageNumber = (() => {
    if (spreadPageIndicator) return spreadPageIndicator.right
    if (pageViewMode === 'single-last') return null
    if (pageViewMode === 'single-first') return 1
    return 2 * spreadIndex + 1
  })()

  const hasLeftPage =
    leftPageNumber != null && leftPageNumber >= 1 && leftPageNumber <= safeTotalPages
  const hasRightPage =
    rightPageNumber != null && rightPageNumber >= 1 && rightPageNumber <= safeTotalPages

  const leftLabel = hasLeftPage && leftPageNumber != null ? pad4(leftPageNumber) : ''
  const rightLabel = hasRightPage && rightPageNumber != null ? pad4(rightPageNumber) : ''

  return { hasLeftPage, hasRightPage, leftLabel, rightLabel }
}
